import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { chunk } from "lodash";
import { WrapWordList } from './Style'; // ודאי נתיב
import { WordsContext } from "./Words";
import { grades, layoutTypes } from "keys";
import { splitArrayDynamically } from "utils/array";
import { WordListPage } from ".";

/**
 * קומפוננטת WordList
 * משמשת כקונטיינר (מעטפת) שאחראי על חיתוך וסידור כל המילים למערכים (דפים),
 * בהתאם להגדרות התצוגה (שורות לעומת בלוקים), הרשאות (markOption), ונקודת סיום.
 * * @param {Array} words - כלל המילים במבדק
 * @param {Object} settings - הגדרות מצב (markOption, viewResults)
 */
const WordList = (props) => {
    const { words, settings } = props;
    
    // קריאת נתונים מה-Context וה-Redux
    const context = useContext(WordsContext);
    const { categoryItem, wordsPerLine } = context || {};
    const category = categoryItem || props.category;
    const wordsPerLineCount = wordsPerLine || props.wordsPerLine;
    const { markOption, viewResults } = settings || {};
    
    const { assessment } = useSelector(state => state.assessment);
    const { endPoint = {}, reading_assessment_grade_of_execution: grade_of_execution } = assessment || {};

    // חילוץ הגדרות תצוגה מבוססות שכבה (כיתה)
    let gradeStyle = grades[grade_of_execution] || {};
    let { columnCount, rowCount, columnGap } = gradeStyle;

    let pages;
    let pageCount;

    // חיתוך רשימת המילים בהתאם לנקודת הסיום (אם לא נמצאים במצב עריכה)
    let nWords = words ? [...words] : [];
    if (!markOption) {
        nWords = words?.slice(0, endPoint?.index);
    }

    // אלגוריתם חלוקת המילים לדפים (Pages)
    if (category.layout === layoutTypes.row) {
        // במבנה של שורות - חותכים בצורה דינמית לפי שדה new_page
        pages = splitArrayDynamically(nWords, "word_def_fe_details.new_page");
    } else {
        // במבנה של עמודות (גריד) - מחשבים כמות מילים מקסימלית לעמוד וחותכים אבסולוטית
        pageCount = (columnCount * rowCount) || 9;
        pages = chunk(nWords, pageCount);
    }

    // משתנה עזר למעקב אחרי מספר המילים שכבר רונדרו בעמודים קודמים
    let totalWords = 0;

    return (
        <WrapWordList
            columnCount={wordsPerLineCount || columnCount}
            columnGap={columnGap}
            $markOption={markOption}
        >
            {pages.map((page, index) => {
                // הוספת אורך העמוד הנוכחי למניין המילים הכולל כדי להעביר את האינדקס המדויק
                const currentTotalWords = totalWords;
                totalWords += page.length;

                return (
                    <React.Fragment key={index}>
                        
                        {/* תצוגת כותרת מספור העמוד (מוסתר אם יש רק מילה אחת בשורה) */}
                        {wordsPerLineCount === 1 || (
                            <div className={`page-number ${(index % 2 && category.layout === layoutTypes.row) ? 'bold-new-page' : ''}`}>
                                {`עמוד ${index + 1}/${pages.length}`}
                            </div>
                        )}
                        
                        {/* רינדור העמוד עצמו על ידי קריאה ל-WordsPage */}
                        <div className={`${category.layout} page`}>
                            <WordListPage
                                prevWordIndex={
                                    category.layout === layoutTypes.row 
                                        ? currentTotalWords // אם זה שורות, משתמשים במצטבר
                                        : index * pageCount // אם זה גריד, מכפילים אינדקס בכמות המילים לדף
                                }
                                words={page}
                                {...settings} 
                            />
                            <div className="new-page"></div>
                        </div>

                    </React.Fragment>
                );
            })}
        </WrapWordList>
    );
};

export default WordList;